import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import ResponseError from "#/types/responseError"
import { Reimbursement } from "#/types/reimbursement"
import { ExpenseType } from "#/utils/ExpenseType"

export const REIMBURSEMENTS_QUERY_KEY = ["reimbursementsQueryKey"]

export function useReimbursements<TData = Reimbursement[]>(
  options?: Pick<UseQueryOptions<Reimbursement[], ResponseError, TData>, "select" | "enabled">
): UseQueryResult<TData, ResponseError> {
  return useQuery<Reimbursement[], ResponseError, TData>({
    queryKey: REIMBURSEMENTS_QUERY_KEY,
    // Refund expenses are folded into their origin expense as an adjustment (see AdjustmentDetails /
    // ReimbursementAmounts) and should never appear as their own activity row. The backend already
    // excludes them from this endpoint; this filter is defense-in-depth.
    queryFn: async () => (await carrotClient.getReimbursements()).filter((r) => r.expenseType !== ExpenseType.REFUND),
    retry: buildCarrotApiRetryPolicy(3),
    ...(options ?? {})
  })
}
